<div mat-dialog-content class="mt-2">
  <mat-checkbox [(ngModel)]="checked" class="mt-2"></mat-checkbox>
  <div [innerHtml]="message" class="message"></div>
</div>
<mat-dialog-actions align="end">
  <div class="buttons">
    <button
      mat-button
      mat-raised-button
      color="primary"
      preventDoubleClick
      [disabled]="!checked"
      (click)="accept()"
    >
      Accept
    </button>
    <button mat-raised-button mat-dialog-close>Cancel</button>
  </div>
</mat-dialog-actions>
